export default "__VITE_ASSET__447033d4__"